import React from 'react';
import Gallery from '../../components/Gallery.js';
import TextBlockOben from '../../components/TextBlockOben';
import {Link} from "react-router-dom";

const images = [
  {
    src: require("../../images/Angorawolle_rotweiß.png"),
    title: '',
    caption: ''
  },
   {
     src: require('../../images/Angorawolle_weißblau.png'),
     title: '',
     caption: ''
   },
   {
     src: require('../../images/Angorawolle_weißgelb.png'),
     title: '',
     caption: ''
   },
   {
     src: require('../../images/MerinoSeide_blauweiß.png'),
     title: '',
     caption: ''
   },
   {
     src: require('../../images/SchafwolleKaschmir_blau.png'),
     title: '',
     caption: ''
   },
   {
     src: require('../../images/SchafwolleMeriino_rotgelb.png'),
     title: '',
     caption: ''
   },
   {
     src: require('../../images/SchafwolleMerino_rot.png'),
     title: '',
     caption: ''
   },
   {
     src: require('../../images/SchafwolleMerino_rotgelb.png'),
     title: '',
     caption: ''
   },
   {
     src: require('../../images/SchafwolleMerino_violett.png'),
     title: '',
     caption: ''
   },
];


const Wolle = (props) => {
  console.log(images);
  return (
    <TextBlockOben>
            <h1>Wolle</h1>
            <p>Aus verschiedenen Rohwollfasern handgesponnene und handgefärbte Garne.</p>
        <Gallery images={images} />
    </TextBlockOben>
  );
}


export { Wolle };
